import { useLang } from '@/app/utils/useLang';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import CalenderIcon from './CalenderIcon';

interface BannerProps {}
const Banner: React.FC<BannerProps> = (props) => {
    const { t } = useLang('Banner');
    const { locale = 'us' } = useRouter();

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1776307860131-byg9sn-compressed-Frame%202094654993.jpg',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1776307876127-badoh5-compressed-Frame%202094655007.jpg',
        label: t('label'),
        title: t('title'),
        desc: (
            <div className={styles.desc}>
                <CalenderIcon />
                {t('desc')}
            </div>
        ),
        lHref: '',
        rHref: '',

        // // 按钮
        // lType: 'filled',
        // lChildren: t('btn1'),
        // lHref: '#',
        // lBtnIsYouToBe: false,

        // // 按钮
        // rType: 'outlined',
        // rChildren: t('btn2'),
        // rHref: 'https://www.youtube.com/embed/zsonj2HPQdM?si=2GSK67QBoFc7Azgk',
        // rBtnIsYouToBe: true,
    };
    return (
        <div className={`page-banner ${styles.Banner} GtmModuleData-section`} id="banner" data-section-id="service-renewal-banner">
            <EcoBanner {...dataA} />
        </div>
    );
};

export default Banner;
